.dn{aspect-ratio:1/1;}